<template>
  <div
    class="segmented-control-option"
    :class="[`segmented-control-option--${value}`]"
  >
    <input
      :id="parentId + '-' + value"
      :checked="checked"
      class="segmented-control-option__input"
      :data-testid="parentId + '-' + value + '-input'"
      :name="parentId"
      type="radio"
      :value="value"
      @input="$emit('update:value', $event.target.value)"
    >
    <label
      class="segmented-control-option__label"
      :data-testid="parentId + '-' + value"
      :for="parentId + '-' + value"
      @mouseleave="hovering = false"
      @mouseover="hovering = true"
    >
      <BaseIcon
        v-if="!!icon"
        class="segmented-control-option__icon"
        :icon="`${icon} ${iconStyle}`"
      />
      <span
        v-if="!!text"
        class="segmented-control-option__text"
        :data-text="text"
      >
        {{ text }}
      </span>
    </label>
  </div>
</template>

<script>
  import BaseIcon from './BaseIcon.vue'

  export default {
    name: 'SegmentedControlOption',
    components: {
      BaseIcon,
    },
    props: {
      parentId: { type: String, required: true },
      value: { type: [Number, String], required: true },
      text: { type: String, default: '' },
      icon: { type: String, default: '' },
      checked: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },
    emits: ['update:value'],
    data() {
      return {
        hovering: false,
      }
    },
    computed: {
      iconStyle() {
        return this.hovering && !this.disabled ? 'fa-solid' : 'fa-regular'
      },
    },
    methods: {
      moouseOver() {
        console.log("mouse over")
      },
    },
  }
</script>

<style scoped lang="scss">
.segmented-control-option {
  display: flex;

  &__input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  &__label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-2);
    height: 32px;
    padding: 4px 12px;
    margin-bottom: 0px;
    color: var(--blueberry-1000, #0C69DD);
    font-weight: var(--emphasis-regular, 400);
    border: none;
    border-radius: 100px;
  }

  &__text::after {
    display: block;
    content: attr(data-text);
    font-weight: var(--emphasis-medium, 500);;
    height: 0px;
    color: transparent;
    overflow: hidden;
    visibility: hidden;
  }

  &__input:checked + &__label {
    border-radius: 100px;
    background-color: var(--grape-jelly-100);
    z-index: 1;
  }

  &__input:not(:checked) + &__label {
    cursor: pointer;
    background-color: var(--salt-1000);
  }

  &__input:not(:checked):not(:disabled) + &__label:hover {
    background-color: var(--grape-jelly-50);
  }

  &__input:not(:checked):not(:disabled) + &__label:hover &__text {
    font-weight: var(--emphasis-medium, 500);
  }

  &__input:not(:checked):not(:disabled) + &__label:hover &__icon {
    font: var(--fa-font-solid);
  }

  &__input:disabled + &__label {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
